"use client"

import { useState } from "react";
import { Check } from "lucide-react";

export function FollowButton() {
  const [isFollowing, setIsFollowing] = useState(false);

  return (
    <button 
      onClick={() => setIsFollowing(!isFollowing)}
      className={`px-6 py-2 text-xs font-bold uppercase tracking-widest transition-all border ${
        isFollowing 
          ? "bg-muted text-foreground border-border" 
          : "bg-brand text-white border-brand hover:bg-brand-dark"
      } flex items-center gap-2 group`}
    >
      {isFollowing ? (
        <>
          <Check size={14} className="text-brand" />
          Following
        </>
      ) : (
        "Follow News Desk"
      )}
    </button>
  );
}
